// This file is auto-generated by @hey-api/openapi-ts

import type {
  AdminCreateCustomerInvitationResponse,
  AdminCreateCustomerRelationInvitationResponse,
  AdminListCustomerPortalUsersResponse,
  AdminRevokeCustomerInvitationResponse,
  ConfigurationFeatureTreeResponse,
  CustomerPortalGetCombinedCustomerOrdersResponse,
  CustomerPortalGetHistoricalOrderDetailResponse,
  CustomersFindCustomersResponse,
  CustomersGetCustomerResponse,
  OrdersGetCustomerOrdersResponse,
  OrdersGetOrderDetailResponse,
  QuotationsFindResponse,
  QuotationsGetDoorListResponse,
  QuotationsGetResponse,
  QuotationsToDoorListResponse,
  QuotationsValidateDoorListItemResponse
} from './types.gen'

const quotationDetailSchemaResponseTransformer = (data: any) => {
  if (data.dateDelivery) {
    data.dateDelivery = new Date(data.dateDelivery)
  }
  return data
}

const pageQuotationDetailSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => quotationDetailSchemaResponseTransformer(item))
  return data
}

export const quotationsFindResponseTransformer = async (
  data: any
): Promise<QuotationsFindResponse> => {
  data = pageQuotationDetailSchemaResponseTransformer(data)
  return data
}

export const quotationsGetResponseTransformer = async (
  data: any
): Promise<QuotationsGetResponse> => {
  data = quotationDetailSchemaResponseTransformer(data)
  return data
}

const doorListFeatureSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

const doorListTreeSchemaResponseTransformer = (data: any) => {
  data.features = data.features.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

export const quotationsToDoorListResponseTransformer = async (
  data: any
): Promise<QuotationsToDoorListResponse> => {
  data = doorListTreeSchemaResponseTransformer(data)
  return data
}

export const quotationsGetDoorListResponseTransformer = async (
  data: any
): Promise<QuotationsGetDoorListResponse> => {
  data = doorListTreeSchemaResponseTransformer(data)
  return data
}

const itemValidationSchemaResponseTransformer = (data: any) => {
  data.features = data.features.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

export const quotationsValidateDoorListItemResponseTransformer = async (
  data: any
): Promise<QuotationsValidateDoorListItemResponse> => {
  data = itemValidationSchemaResponseTransformer(data)
  return data
}

const opendoorsApiCustomersSchemasCustomerSchemaResponseTransformer = (data: any) => {
  if (data.lastModified) {
    data.lastModified = new Date(data.lastModified)
  }
  return data
}

const pageCustomerSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) =>
    opendoorsApiCustomersSchemasCustomerSchemaResponseTransformer(item)
  )
  return data
}

export const customersFindCustomersResponseTransformer = async (
  data: any
): Promise<CustomersFindCustomersResponse> => {
  data = pageCustomerSchemaResponseTransformer(data)
  return data
}

const customerDetailSchemaResponseTransformer = (data: any) => {
  if (data.lastModified) {
    data.lastModified = new Date(data.lastModified)
  }
  return data
}

export const customersGetCustomerResponseTransformer = async (
  data: any
): Promise<CustomersGetCustomerResponse> => {
  data = customerDetailSchemaResponseTransformer(data)
  return data
}

const customerOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.productionStartDate) {
    data.productionStartDate = new Date(data.productionStartDate)
  }
  if (data.productionEndDate) {
    data.productionEndDate = new Date(data.productionEndDate)
  }
  return data
}

const pageCustomerOrderViewSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => customerOrderViewSchemaResponseTransformer(item))
  return data
}

export const ordersGetCustomerOrdersResponseTransformer = async (
  data: any
): Promise<OrdersGetCustomerOrdersResponse> => {
  data = pageCustomerOrderViewSchemaResponseTransformer(data)
  return data
}

const subOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.deliverAt) {
    data.deliverAt = new Date(data.deliverAt)
  }
  data.createdAt = new Date(data.createdAt)
  return data
}

const orderDetailViewSchemaResponseTransformer = (data: any) => {
  data.subOrders = data.subOrders.map((item: any) => subOrderViewSchemaResponseTransformer(item))
  return data
}

export const ordersGetOrderDetailResponseTransformer = async (
  data: any
): Promise<OrdersGetOrderDetailResponse> => {
  data = orderDetailViewSchemaResponseTransformer(data)
  return data
}

const configurationNodeSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => configurationNodeSchemaResponseTransformer(item))
  return data
}

const configurationTreeSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => configurationNodeSchemaResponseTransformer(item))
  return data
}

export const configurationFeatureTreeResponseTransformer = async (
  data: any
): Promise<ConfigurationFeatureTreeResponse> => {
  data = configurationTreeSchemaResponseTransformer(data)
  return data
}

const customerInvitationResponseSchemaResponseTransformer = (data: any) => {
  data.expiresAt = new Date(data.expiresAt)
  return data
}

export const adminCreateCustomerInvitationResponseTransformer = async (
  data: any
): Promise<AdminCreateCustomerInvitationResponse> => {
  data = customerInvitationResponseSchemaResponseTransformer(data)
  return data
}

export const adminCreateCustomerRelationInvitationResponseTransformer = async (
  data: any
): Promise<AdminCreateCustomerRelationInvitationResponse> => {
  data = customerInvitationResponseSchemaResponseTransformer(data)
  return data
}

export const adminRevokeCustomerInvitationResponseTransformer = async (
  data: any
): Promise<AdminRevokeCustomerInvitationResponse> => {
  data = customerInvitationResponseSchemaResponseTransformer(data)
  return data
}

const customerPortalUserResponseSchemaResponseTransformer = (data: any) => {
  if (data.invitationCreated) {
    data.invitationCreated = new Date(data.invitationCreated)
  }
  if (data.invitationModified) {
    data.invitationModified = new Date(data.invitationModified)
  }
  if (data.invitationExpiresAt) {
    data.invitationExpiresAt = new Date(data.invitationExpiresAt)
  }
  if (data.invitationAcceptedAt) {
    data.invitationAcceptedAt = new Date(data.invitationAcceptedAt)
  }
  if (data.accountCreated) {
    data.accountCreated = new Date(data.accountCreated)
  }
  if (data.accountModified) {
    data.accountModified = new Date(data.accountModified)
  }
  return data
}

const pageCustomerPortalUserResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) =>
    customerPortalUserResponseSchemaResponseTransformer(item)
  )
  return data
}

export const adminListCustomerPortalUsersResponseTransformer = async (
  data: any
): Promise<AdminListCustomerPortalUsersResponse> => {
  data = pageCustomerPortalUserResponseSchemaResponseTransformer(data)
  return data
}

const combinedOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.nextDeliveryDate) {
    data.nextDeliveryDate = new Date(data.nextDeliveryDate)
  }
  return data
}

const combinedOrderPageSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => combinedOrderViewSchemaResponseTransformer(item))
  return data
}

export const customerPortalGetCombinedCustomerOrdersResponseTransformer = async (
  data: any
): Promise<CustomerPortalGetCombinedCustomerOrdersResponse> => {
  data = combinedOrderPageSchemaResponseTransformer(data)
  return data
}

const historicalOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.deliverAt) {
    data.deliverAt = new Date(data.deliverAt)
  }
  if (data.createdAt) {
    data.createdAt = new Date(data.createdAt)
  }
  return data
}

const historicalOrderDetailViewSchemaResponseTransformer = (data: any) => {
  data.subOrders = data.subOrders.map((item: any) =>
    historicalOrderViewSchemaResponseTransformer(item)
  )
  return data
}

export const customerPortalGetHistoricalOrderDetailResponseTransformer = async (
  data: any
): Promise<CustomerPortalGetHistoricalOrderDetailResponse> => {
  data = historicalOrderDetailViewSchemaResponseTransformer(data)
  return data
}
